import { render, staticRenderFns } from "./FmPoptip.vue?vue&type=template&id=312bb7e6&"
import script from "./FmPoptip.vue?vue&type=script&lang=js&"
export * from "./FmPoptip.vue?vue&type=script&lang=js&"
import style0 from "./FmPoptip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports